<template>
    <div class="position-box">
      <div id="header" class="currency-bg">
        <img class="header-back" src="@/assets/icon_back.png"  alt="" @click="goBack">
        <span>{{$t('langNew.wyjb')}}</span>
        <div class="recored" @click="link">
          <img class="icon" src="@/assets/new/dingdan-white.png" alt="">
          <div class="text">{{$t('wydb.jl')}}</div>
        </div>
      </div>
		  <div id="currency" class="currency-box">
			<div class="head-wrap">
				<div class="head-box">
					<div class="t1">{{$t('wydb.dbz')}}</div>
					<div class="t2"><span class="money">{{lend_now}}</span> / USDC</div>
					<div class="btn" v-show="lend_now > 0" @click="goRecharge">{{$t('wydb.qhk')}}</div>
				</div>
				<div class="item-box">
					<div class="item">
						<div class="t1">{{$t('wydb.ljdb')}}(usdc)</div>
						<div class="t2">≈ {{lend_history}}</div>
					</div>
					<div class="item">
						<div class="t1">{{$t('wydb.dhkbs')}}</div>
						<div class="t2 c2">{{lend_count}}</div>
					</div>
				</div>
			</div>
			<div class="tbody-box">
				<ul class="item1-box">
					<li class="item">
						<div class="text">{{$t('wydb.jkje')}}(usdc)</div>
						<div class="text">{{$t('wydb.jdzq')}}</div>
					</li>
					<li class="item item2">
						<input class="input number" type="number" v-model="amount" @keyup="keyMoney()" :placeholder="$t('wydb.qsrje')">
						<div class="text">
							<div class="time trigger1">{{cycleArrDft.cycle_days}}</div>
							<img class="icon trigger1" src="@/assets/new/xialajiantou.png" alt="">
						</div>
					</li>
				</ul>
				<ul class="item2-box">
					<li class="item">
						<div class="text">{{$t('wydb.rll')}}</div>
						<div class="text">{{cycleArrDft.day_rate}}%</div>
					</li>
					<li class="item">
						<div class="text">{{$t('wydb.hkfs')}}</div>
						<div class="text">{{$t('wydb.dqych')}}</div>
					</li>
					<li class="item">
						<div class="text">{{$t('wydb.lx')}}</div>
						<div class="text">{{lx | toFixed4}}</div>
					</li>
					<li class="item">
						<div class="text">{{$t('wydb.fkjg')}}</div>
						<div class="text">{{cycleArrDft.company}}</div>
					</li>
				</ul>
				<div class="tips">{{$t('wydb.tpsc')}}</div>
				<ul class="item3-box">
					<li class="item">
						<img class="img js-fwxx" src="@/assets/btn-upload.png" @click="upload(1)" alt="">
						<div class="text">{{$t('wydb.fwxx')}}</div>
					</li>
					<li class="item">
						<img class="img js-srzm" src="@/assets/btn-upload.png" @click="upload(2)" alt="">
						<div class="text">{{$t('wydb.srzm')}}</div>
					</li>
					<li class="item">
						<img class="img js-yhmx" src="@/assets/btn-upload.png" @click="upload(3)" alt="">
						<div class="text">{{$t('wydb.yhmx')}}</div>
					</li>
					<li class="item">
						<img class="img js-zjz" src="@/assets/btn-upload.png" @click="upload(4)" alt="">
						<div class="text">{{$t('wydb.zjz')}}</div>
					</li>
				</ul>
			</div>
			<div class="btn-box">
				<div class="radio-box"><input id="agree" name="agree" v-model="isChecked" type="checkbox"><label class="text" for="agree"><span>{{$t('wydb.yd')}}</span> <span class="blue" @click="agreement">{{$t('wydb.xy')}}</span></label></div>
				<button class="btn btn-bg" :class="{active: isChecked}" type="button" @click="submit">{{$t('wydb.sqdb')}}</button>
			</div>
        </div>
         <div class="load-box" v-show="isLoad" @click="hideLoad"><img class="load" src="@/assets/new/loading.gif" alt=""></div>
    </div>
</template>

<script>
import lrz from "lrz";
let that = this;
let vm = null;
export default {
    name: 'currency',
    data () {
        return {
            theme: false,
            isLoad: false,
            lend_now: '',
            lend_history: '',
            lend_count: '',
            cycleArrDft: {},
            cycleArr: [],
            dayArr: [],
            amount: '',
            photo_fwxx: '',
            photo_srzm: '',
            photo_yhmx: '',
            photo_zjz: '',
            isChecked: false,
            imgId: '',
            lx: 0.0000,
            isHouse: 0,
            isMoney: 0,
            isBank: 0,
            isCert: 0,
            count: 1
        }
    },
    beforeCreate(){
        that = this;
    },
    created(){
        vm = this;
        this.theme = JSON.parse(localStorage.getItem('theme'));
    },
    mounted() {
      this.getLendMy();
      this.getLendList();
    },
    methods: {
       goBack(){
          this.$router.push('/index')
       },
       link(){
           this.$router.push('/currencyRecord')
       },
       hideLoad(){
           this.isLoad = false
       },
        getLendImg(){
        this.$ajax.get('/web/lend_img',{}).then((res) => {
            let resData = res.data.data;
            this.isHouse = resData.img_house;
            this.isMoney = resData.img_money;
            this.isBank = resData.img_bank;
            this.isCert = resData.img_cert;
        }).catch(function(err){
            console.log(err)
        })
       },
      goRecharge(){
        this.$router.push('/currencyRecord')
      },
      getLendMy(){//贷币信息
          let that = this;
          this.$ajax.get('/web/lendMy',{}).then((res) => {
              let resData = res.data.data;
              if(res.data.code == 1000){
                return false
              }
              that.lend_now = resData.lend_now;
              that.lend_history = resData.lend_histor;
              that.lend_count = resData.lend_count;
          }).catch(function(err){
              console.log(err)
          })
      },
      getLendList(){//周期
          let that = this;
          this.$ajax.get('/web/lendList',{}).then((res) => {
              let resData = res.data.data;
              that.cycleArr = resData;
              that.cycleArrDft = resData[0];
              localStorage.setItem('fkjg',resData[0].company)
              that.dayArr = resData.map((item) => {
                  return item.cycle_days
              });
              that.getDaySelect()
          }).catch(function(err){
              console.log(err)
          })
      },
      submit(){
          if(!this.isChecked) return;
          var that = this;
          let data = {
              id: this.cycleArrDft.id,
              amount: this.amount,
              img_house: this.photo_fwxx,
              img_money: this.photo_srzm,
              img_bank: this.photo_yhmx,
              img_cert: this.photo_zjz,
          }
          if(!this.amount || this.amount <= 0){
              this.$toast.center(this.$t('wydb.qsrje'));
              return;
          }
          if(this.count == 1){
              this.count = 0;
          }else{
              return false;
          }
          this.$ajax.post('/web/lendBuy',data).then((res) => {
              let resData = res.data;
              if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                this.$toast.center(this.$t('status.statusText')[2]);
                setTimeout(() => {
                    this.count = 1;
                    this.$router.push('/currencyRecord')
                }, 1000)
              }else{
                  this.count = 1;
                  this.$toast.center(this.$t('tipsNew.qscpztp'));
                  return;
              }

          }).catch(function(err){
              console.log(err)
          })
      },
      upload(id){
          this.imgId = id;
          this.uploadimg(function (res) {

          })
      },
      uploadimg(callback){
        let that = this;
        that.ele_input(function(res) {
          if (res.length > 0) {
            var formdata = new FormData();
            for (var i = 0, len = res.length; i < len; i++) {
              lrz(res[0]).then(function (rst) {
                var formdata = new FormData();
                let file = new window.File([rst.file],rst.origin.name, {type: rst.file.type});
                formdata.append('file', file);
                formdata.append('token', localStorage.getItem('token'));
                formdata.append('app', 'h5');
                that.isLoad = true;
                $.ajax({
                  url: that.domain + "/web/uploadImg",
                  type: "POST",
                  data: formdata,
                  cache: false,
                  processData: false,
                  contentType: false,
                  success: function(data) {
                    if (typeof data == 'string') data = JSON.parse(data.data)
                    if (data && data.code == 0) {
                      that.isLoad = false;
                      if(that.imgId == 1){
                        $('.js-fwxx').attr('src', data.data.url);
                        that.photo_fwxx = data.data.url;
                      }else if(that.imgId == 2){
                        $('.js-srzm').attr('src', data.data.url);
                        that.photo_srzm = data.data.url;
                      }else if(that.imgId == 3){
                        $('.js-yhmx').attr('src', data.data.url);
                        that.photo_yhmx = data.data.url;
                      }else{
                        $('.js-zjz').attr('src', data.data.url);
                        that.photo_zjz = data.data.url;
                      }
                    }else{
                      that.isLoad = false;
                      that.$toast.center(data.message);
                      return;
                    }
                  },error: function(data) {
                    that.isLoad = false;
                    that.$toast.center(data.message);
                    return;
                  }
                });
              })
            }
          }
        })
      },
      ele_input(callback){
        var inputs = document.querySelector('.___input')
        if (!!inputs) {
          inputs.onchange = null
          inputs.onclick = null
          inputs.remove(0)
        }
        var input = document.createElement('input')
        input.className = '___input'
        input.type = 'file'
        input.style.display = 'none'
        input.onchange = function() {
          var arr = []
          for (var i = 0, len = this.files.length; i < len; i++) {
            arr.push(this.files[i])
          }
          callback(arr)
        }
        input.accept = 'image/*'
        input.click();
        document.body.appendChild(input);
      },
      agreement(){
          this.$router.push('/agreement')
      },
      keyMoney(){//输入数量规则
          var amount =  $('.number').val();
          amount = amount.replace(/[^\d.]/g, "");  //仅保留数字和"."
          amount = amount.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
          amount = amount.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
          amount = amount.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
          if (amount.indexOf(".") < 0 && amount != "") { //首位是0的话去掉
              amount = parseFloat(amount)
          }
          $('.number').val(amount)
      },
      getDaySelect(){
        var weekdayArr = [];
        setTimeout(() => {
          weekdayArr = vm.dayArr;
          var mobileSelect1 = new MobileSelect({
              trigger: '.trigger1',
              title: vm.$t('wydb.jdzq'),
              wheels: [
                  {data: weekdayArr}
              ],
              ensureBtnText: vm.$t('wydb.qd'),
              cancelBtnText: vm.$t('wydb.gb'),
              position:[0], //初始化定位 打开时默认选中的哪个 如果不填默认为0
              transitionEnd:function(indexArr, data){
                  for(var i=0;i< vm.cycleArr.length;i++){
                      var p = vm.cycleArr[i];
                      if(p.cycle_days == data[0]){
                          vm.cycleArrDft = p
                      }
                  }
              },
              callback:function(indexArr, data){
                  // console.log(data);
              }
          })
        },1500)
      }
    },
    watch:{
      amount:function(){
        if(this.amount){
          var rate = parseFloat(this.amount) * parseFloat(this.cycleArrDft.day_rate) / 100 * this.cycleArrDft.cycle_days;
          this.lx = parseFloat(rate).toFixed(4);
        }else{
          this.lx = 0;
        }
      },
      cycleArrDft:function(){
        if(this.amount){
          var rate = parseFloat(this.amount) * parseFloat(this.cycleArrDft.day_rate) / 100 * this.cycleArrDft.cycle_days;
          this.lx = parseFloat(rate).toFixed(4);
        }else{
          this.lx = 0;
        }
      },
    },
    beforeDestroy(){

    }
}
$(function(){

})
</script>
<style scoped>
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
    }
    .cotainer{
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;
        background: #f9f9f9;
        overflow-y: scroll;
    }
    #header {
        position: fixed;
        width: 100%;
        height: 1.86rem;
        color: #fff;
        font-size: .48rem;
        line-height: 1.86rem;
        background: #25282D;
        text-align: center;
    }
    .header-back{
        position: absolute;
        left: .3rem;
        top: 50%;
        width: .36rem;
        height: .66rem;
        margin-top: -.33rem;
    }
    .recored{
        position: absolute;
        right: .54rem;
        top: 50%;
        display: flex;
        align-items: center;
        font-size: .36rem;
        transform: translateY(-50%);
    }
    .recored .icon{
        width: .45rem;
        height: .54rem;
        margin-right: .18rem;
    }
    .currency-box{
        position: absolute;
        left: 0;
        top: 1.85rem;
        bottom: 3.3rem;
        width: 100%;
        height: auto;
        overflow: scroll;
    }
    .head-wrap{
        padding-bottom: 1.86rem;
        background: #25282D;
    }
    .head-box{
        color: #fff;
        font-size: .42rem;
        background: url('../assets/new/circle-bg.png') no-repeat center .12rem!important;
        background-size: 6.15rem 3.54rem!important;
        text-align: center;
    }
    .head-box .t1{
        font-size: .4rem;
        padding: .9rem 0 .6rem;
    }
    .head-box .t2 .money{
        font-size: .54rem;
    }
    .head-box .btn{
        width: 2.85rem;
        height: .72rem;
        margin: .6rem auto 0;
        color: #fff;
        font-size: .36rem;
        line-height: .72rem;
        background: #3578FD;
        border-radius: .36rem;
        text-align: center;
    }
    .head-wrap .item-box{
        display: flex;
        justify-content: space-between;
        align-items: stretch;
        width: 7.08rem;
        margin: .38rem auto 0;
        color: #969799;
        font-size: .36rem;
        text-align: center;
    }
    .head-wrap .item-box .t2{
        position: relative;
        padding-top: .24rem;
        color: #fff;
        font-size: .42rem;
    }
    .head-wrap .item-box .t2::after{
        position: absolute;
        left: 50%;
        bottom: -.48rem;
        content: '';
        width: .36rem;
        height: .09rem;
        margin-left: -.18rem;
        background: #AD701C;
        border-radius: 1px;
    }
    .head-wrap .item-box .t2.c2::after{
        background: #AB3137;
    }
    .tbody-box{
        margin-top: -.75rem;
        padding: 0 .36rem .6rem;
    }
    .tbody-box .item1-box{
        padding: .48rem .42rem .72rem;
        color: #fff;
        font-size: .42rem;
        background: #131e30;
        border-radius: .2rem;
    }
    .tbody-box .item1-box .item{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .tbody-box .item1-box input::-webkit-input-placeholder{color: #4489D7;font-size: 13px;}
    .tbody-box .item1-box .item2{
        margin-top: .36rem;
        border-bottom: 1px solid #313a47;
    }
    .tbody-box .item1-box .text{
        display: flex;
        align-items: center;
    }
    .tbody-box .item1-box .input{
        flex: 1;
        padding: .36rem 0;
        color: #fff;
    }
    .tbody-box .item1-box .time{
        padding: 0 .18rem;
        color: #fff;
        font-size: .48rem;
        font-weight: bold;
    }
    .tbody-box .item1-box .icon{
        width: .42rem;
        height: .24rem;
    }
    .tbody-box .item2-box{
        margin-top: .36rem;
        padding: 0 .42rem;
        background: #131e30;
        border-radius: .2rem;
    }
    .tbody-box .item2-box .item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #fff;
        font-size: .42rem;
        padding: .54rem 0;
        border-bottom: 1px solid #313a47;
    }
    .tbody-box .item2-box .item:last-child{
        border-bottom: none;
    }
    .tbody-box .tips{
        position: relative;
        margin: .42rem 0 .36rem;
        padding-left: .36rem;
        color: #fff;
        font-size: .42rem;
    }
    .tbody-box .tips::before{
        position: absolute;
        left: 0;
        content: '';
        width: .06rem;
        height: .42rem;
        background: #4489D7;
    }
    .tbody-box .item3-box{
        display: flex;
        justify-content: space-between;
        align-items: stretch;
        flex-wrap: wrap;
        padding: .72rem .48rem .24rem;
        background: #131e30;
        border-radius: .2rem;
    }
    .tbody-box .item3-box .item{
        position: relative;
        width: 4.32rem;
        margin-bottom: .48rem;
    }
    .tbody-box .item3-box .item .text{
        width: 100%;
        color: #7C7C7C;
        font-size: .36rem;
        text-align: center;
    }
    .tbody-box .item3-box .item .img{
        width: 4.32rem;
        height: 2.46rem;
    }
    .btn-box{
        position: fixed;
        bottom: 0;
        width: 100%;
        padding: .48rem .78rem;
        background: #131e30;
        box-sizing: border-box;
    }
    .btn-box .radio-box{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .btn-box .text{
        padding-left: .3rem;
        color: #fff;
        font-size: .36rem;
    }
    .btn-box .text .blue{
      color: #588bf8;
    }
    .btn-box .btn{
        display: block;
        width: 100%;
        height: 1.2rem;
        margin-top: .45rem;
        font-size: .48rem;
        line-height: 1.2rem;
        background: #acacac;
    }
    .btn-box .btn.active{
      background: #588bf8;
    }
</style>



// WEBPACK FOOTER //
// src/pages/currency.vue